import { Field, ID, InputType, ObjectType } from 'type-graphql'
import type { AiMessageRoleEnum } from './AiMessageRoleEnum'

@ObjectType()
@InputType('AiMessageInput')
export class AiMessage {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  role: AiMessageRoleEnum

  @Field(() => String)
  content: string

  @Field(() => String)
  topic: string
}
